import Vue from 'vue'
import Router from 'vue-router'

import Home from './components/Home.vue'
import Auditing from './components/admin/Auditing.vue'
import Alerts from './components/admin/Alerts.vue'
import Users from './components/user/Users.vue'
import Species from './components/management/Species.vue'
import Locations from './components/management/Locations.vue'
import Suppliers from './components/management/Suppliers.vue'
import VenomTypes from './components/management/VenomTypes.vue'
import Specimens from './components/specimens/Specimens.vue'
import MoveRack from './components/specimens/MoveRack.vue'
import Husbandry from './components/specimens/Husbandry.vue'
import VenomProfile from './components/specimens/VenomProfile.vue'
import PrintBarcode from './components/specimens/PrintBarcode.vue'

import DailyExtractions from "@/components/venompooling/DailyExtractions.vue";
import DailyExtractionSession from "@/components/venompooling/DailyExtractionSession.vue";
import MonthlyPools from "@/components/venompooling/MonthlyPools.vue";
import MonthlyPoolManagement from "@/components/venompooling/MonthlyPoolManagement.vue";
import DailyMonthBatchRecord from "@/components/venompooling/DailyMonthBatchRecord.vue";
import VenomLots from "@/components/venompooling/VenomLots.vue";
import VenomLot from "@/components/venompooling/VenomLot.vue";
import SpeciesBatchPools from "@/components/venompooling/SpeciesBatchPools.vue";
import SpeciesBatchPool from "@/components/venompooling/SpeciesBatchPool.vue";
import ReleaseCertificate from "@/components/venompooling/ReleaseCertificate.vue";

import HusbandryReporting from './components/reporting/HusbandryReporting.vue'
import HusbandryRoomActivityReport from "@/components/reporting/HusbandryRoomActivityReport.vue";

import PrintSpecimen from '@/components/specimens/PrintSpecimen.vue';
import PrintDailyExtraction from '@/components/venompooling/PrintDailyExtraction.vue';
import PrintMonthlyPool from '@/components/venompooling/PrintMonthlyPool.vue';
import PrintSpeciesBatchPool from '@/components/venompooling/PrintSpeciesBatchPool.vue';
import PrintVenomLot from '@/components/venompooling/PrintVenomLot.vue';

import MedicalRecordDetails from '@/components/medicalRecords/MedicalRecordDetails.vue';
import MedicalRecords from '@/components/medicalRecords/MedicalRecords.vue'

import LoginError from './components/authentication/LoginError.vue'
import LoggingIn from './components/authentication/LoggingIn.vue'
import LogOut from './components/authentication/LogOut.vue'
import LoggedOut from './components/authentication/LoggedOut.vue'
import NotAuthorized from './components/authentication/NotAuthorized.vue'

import store from "./store";
import * as auth from "./services/auth"
import permissions from 'comunet-btg-utah-repository-shared/permissions'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: "Home",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS
                ]
            }
        },
        {
            path: '/auditing',
            name: 'auditing',
            component: Auditing,
            meta: {
                title: "Auditing",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.ADMIN
                ]
            }
        },
        {
            path: '/users',
            name: 'users',
            component: Users,
            meta: {
                title: "Users",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.ADMIN
                ]
            }
        },
        {
            path: '/alerts',
            name: 'alerts',
            component: Alerts,
            meta: {
                title: "Alerts",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.ADMIN
                ]
            }
        },
        {
            path: '/species',
            name: 'species',
            component: Species,
            meta: {
                title: "Species",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.ADMIN
                ]
            }
        },
        {
            path: '/locations',
            name: 'locations',
            component: Locations,
            meta: {
                title: "Locations",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.ADMIN
                ]
            }
        },
        {
            path: '/suppliers',
            name: 'suppliers',
            component: Suppliers,
            meta: {
                title: "Suppliers",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.ADMIN
                ]
            }
        },
        {
            path:'/venomtypes',
            name:'venomtypes',
            component: VenomTypes,
            meta: {
                title: "Venom Types",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.ADMIN
                ]
            }
        },
        {
            path: '/husbandry/:specimenDisplayID',
            name: 'husbandrywithid',
            component: Husbandry,
            props: true,
            meta: {
                title: "Husbandry",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.DAILY_HUSBANDRY
                ]
            }
        },
        {
            path: '/husbandry',
            name: 'husbandry',
            component: Husbandry,
            meta: {
                title: "Husbandry",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.DAILY_HUSBANDRY
                ]
            }
        },
        {
            path: '/husbandryreporting',
            name: 'husbandryreporting',
            component: HusbandryReporting,
            meta: {
                title: "Husbandry Reporting",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.DAILY_HUSBANDRY
                ]
            }
        },
        {
            path: '/husbandryroomreport',
            name: 'husbandryroomreport',
            component: HusbandryRoomActivityReport,
            meta: {
                title: "Husbandry Room Activity Report",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS
                ]
            }
        },
        {
            path: '/venomprofile',
            name: 'venomprofile',
            component: VenomProfile,
            meta: {
                title: "Venom Profile",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.VENOM_PROFILE
                ]
            }
        },
        {
            path: '/venomprofile/:specimenDisplayID',
            name: 'venomprofilewithid',
            component: VenomProfile,
            props: true,
            meta: {
                title: "Venom Profile",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.VENOM_PROFILE
                ]
            }
        },
        {
            path: '/printbarcode/:barcode',
            name: 'printbarcode',
            component: PrintBarcode,
            props: true,
            meta: {
                title: "Print Barcode",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS
                ]
            }
        },
        {
            path: '/specimens',
            name: 'specimens',
            component: Specimens,
            props: true,
            meta: {
                title: "Specimens",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.NEW_SPECIMEN
                ]
            }
        },
        {
            path: '/moverack',
            name: 'moverack',
            component: MoveRack,
            props: true,
            meta: {
                title: "Move all Specimens in Rack",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.NEW_SPECIMEN
                ]
            }
        },
        {
            path: '/dailyextractions',
            name: 'dailyextractions',
            component: DailyExtractions,
            props: true,
            meta: {
                title: "Daily Extractions",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.DAILY_EXTRACTION
                ]
            }
        },
        {
            path: '/dailyextractionsession',
            name: 'dailyextractionsession',
            component: DailyExtractionSession,
            meta: {
                title: "Daily Extraction Session",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.DAILY_EXTRACTION
                ]
            }
        },
        {
            path: '/dailyextractionsession/:openSessionID',
            name: 'dailyextractionsessionbyid',
            component: DailyExtractionSession,
            props: true,
            meta: {
                title: "Daily Extraction Session",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.DAILY_EXTRACTION
                ]
            }
        },
        {
            path: '/monthlypoolmanagement',
            name: 'monthlypoolmanagement',
            component: MonthlyPoolManagement,
            meta: {
                title: "Manage Monthly Pool",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS
                ]
            }
        },
        {
            path: '/monthlypoolmanagement/:monthlyPoolID',
            name: 'monthlypoolmanagementbyid',
            component: MonthlyPoolManagement,
            props: true,
            meta: {
                title: "Manage Monthly Pool",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS
                ]
            }
        },
        {
            path: '/monthlypools/dailymonthbatchrecord/:monthlyPoolID',
            name: 'dailymonthbatchrecordbyid',
            component: DailyMonthBatchRecord,
            props: true,
            meta: {
                title: "Daily Month Batch Record",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS
                ]
            }
        },
        {
            path: '/monthlypools',
            name: 'monthlypools',
            component: MonthlyPools,
            props: true,
            meta: {
                title: "Monthly Pools",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS
                ]
            }
        },
        {
            path: '/venomlots',
            name: 'venomlots',
            component: VenomLots,
            props: true,
            meta: {
                title: "Venom Lots",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS
                ]
            }
        },
        {
            path: '/venomlot/:venomLotID?',
            name: 'venomLot',
            component: VenomLot,
            meta: {
                title: "Manage Venom Lot",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS
                ]
            }
        },
        {
            path: '/speciesbatchpools',
            name: 'speciesBatchPools',
            component: SpeciesBatchPools,
            meta: {
                title: "Species Batch Pools",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS
                ]
            }
        },
        {
            path: '/speciesbatchpool/:speciesBatchPoolID?',
            name: 'speciesBatchPool',
            component: SpeciesBatchPool,
            meta: {
                title: "Manage Species Batch Pool",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS
                ]
            }
        },
        {
            path: '/releasecertificate/:venomLotID?',
            name: 'releaseCertificate',
            component: ReleaseCertificate,
            meta: {
                title: "Release Certificate",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.RELEASE_CERTIFICATE
                ]
            }
        },
        // Print routes
        {
            path: '/print/specimen/:specimenID',
            name: 'printspecimen',
            component: PrintSpecimen,
            props: true,
            meta: {
                title: "Print Specimen",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.NEW_SPECIMEN
                ]
            }
        },
        {
            path: '/print/dailyextractionsession/:dailyExtractionSessionID',
            name: 'printdailyextractionsession',
            component: PrintDailyExtraction,
            props: true,
            meta: {
                title: "Print Daily Extraction Session",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.DAILY_EXTRACTION
                ]
            }
        },
        {
            path: '/print/monthlypool/:monthlyPoolID',
            name: 'printmonthlypool',
            component: PrintMonthlyPool,
            props: true,
            meta: {
                title: "Print Monthly Pool",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS
                ]
            }
        },
        {
            path: '/print/speciesbatchpool/:speciesBatchPoolID',
            name: 'printspeciesbatchpool',
            component: PrintSpeciesBatchPool,
            props: true,
            meta: {
                title: "Print Species Batch Pool",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS
                ]
            }
        },
        {
            path: '/print/venomlot/:venomLotID',
            name: 'printvenomlot',
            component: PrintVenomLot,
            props: true,
            meta: {
                title: "Print Venom Lot",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS
                ]
            }
        },
        {
            path: '/medicalRecords',
            name: 'medicalRecords',
            component: MedicalRecords,
            props: true,
            meta: {
                title: "Medical Records",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.MEDICAL_RECORD_ACCESS
                ]
            }
        },
        {
            path: '/medicalRecords/:medicalRecordID',
            name: 'medicalRecordDetails',
            component: MedicalRecordDetails,
            props: true,
            meta: {
                title: "Medical Record Details",
                requiredPermissions: [
                    permissions.ACCESS_LEVELS.ACCESS,
                    permissions.ACCESS_LEVELS.MEDICAL_RECORD_ACCESS
                ]
            }
        },
        {
            path: '/loggingin',
            name: 'loggingin',
            component: LoggingIn,
            meta: {
                title: "Logging In...",
                hideMenus: true,
                notDefault: true
            }
        },
        {
            path: '/loginerror',
            name: 'loginerror',
            component: LoginError,
            meta: {
                title: "Login Error",
                hideMenus: true,
                notDefault: true,
                doNotAttemptToProcessLogin: true
            }
        },
        {
            path: '/logout',
            name: 'logout',
            component: LogOut,
            meta: {
                title: "Logging Out...",
                hideMenus: true,
                notDefault: true
            }
        },
        {
            path: '/loggedout',
            name: 'loggedout',
            component: LoggedOut,
            meta: {
                title: "Logged Out",
                hideMenus: true,
                notDefault: true
            }
        },
        {
            path: '/notauthorized',
            name: 'notauthorized',
            component: NotAuthorized,
            meta: {
                title: "Not Authorized",
                notDefault: true
            }
        }
    ]
});

// Global route guard
router.beforeEach(async(to, from, next) => {
    try {
        /**
         * Some good documentation on the authentication Javscript library we are using: https://www.npmjs.com/package/@azure/msal-browser
         */

        const authLogID = Math.floor(Math.random() * 1000000000) + 1;
        const authLogPrefix = "AUTH (request id: " + authLogID + "): ";
        const authLoggingEnabled = process.env.VUE_APP_AUTH_LOGGING_ENABLED === "true";

        // eslint-disable-next-line no-console
        authLoggingEnabled && console.log(authLogPrefix + "navigating to " + to.name + "");

        // Use the page's router title to name the page
        if (to.meta && to.meta.title) {
            document.title = to.meta.title;
        }

        store.commit("generalStore/setLoadingRoute", true);

        /**
         * "If your application uses redirects for interaction, handleRedirectPromise must be called and awaited on
         * each page load before determining if a user is signed in or not"
         * - https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/samples/msal-browser-samples/vue3-sample-app/src/router/Guard.ts
         */
        let tokenResponse = await auth.msalInstance.handleRedirectPromise();

        if (tokenResponse) {
            // we are coming back from a successful authentication redirect
            // eslint-disable-next-line no-console
            authLoggingEnabled && console.log(authLogPrefix + "tokenResponse: " + JSON.stringify(tokenResponse));
        }

        // check whether or not the current user is authenticated
        const accounts = auth.msalInstance.getAllAccounts();
        const isAuthenticated = accounts && accounts.length > 0;

        if (isAuthenticated) {
            // eslint-disable-next-line no-console
            authLoggingEnabled && console.log(authLogPrefix + "attempting to acquire access token");

            let authResult;

            try {
                authResult = await auth.acquireTokenSilent();
            }
            catch (err) {
                // eslint-disable-next-line no-console
                authLoggingEnabled && console.log(authLogPrefix + "failed to acquire access token");

                // eslint-disable-next-line no-console
                authLoggingEnabled && console.log(authLogPrefix + JSON.stringify(err));

                // eslint-disable-next-line no-console
                authLoggingEnabled && console.log(authLogPrefix + "calling acquireTokenRedirect");

                auth.acquireTokenRedirect();

                return;
            }

            if (authResult) {
                // eslint-disable-next-line no-console
                authLoggingEnabled && console.log(authLogPrefix + "accessToken: " + JSON.stringify(authResult.accessToken));
            }
        }

        // eslint-disable-next-line no-console
        authLoggingEnabled && console.log(authLogPrefix + "isAuthenticated: " + isAuthenticated);

        // make sure that we've cleared user information if they are not logged in
        if (!isAuthenticated) {
            auth.forgetUser();
        }

        // if we are authenticated but we are missing the user object, then go fetch it
        if (isAuthenticated) {
            // doNotAttemptToProcessLogin helps us avoid an infinite loop of navigating to the /loginerror page and continually failing to fetch the user object
            if (!store.state.authStore.user && !to.meta.doNotAttemptToProcessLogin && to.meta.requiredPermissions) {
                try {
                    // fetch the user details from our database for use in determining permissions
                    await auth.processLogin();
                } catch (err) {
                    // redirect to a page indicating an error, and display that error in the console
                    next({
                        path: "/loginerror",
                        query: {
                            errorMessage: err.message
                        }
                    });

                    throw err;
                }
            }
        }

        if (to.meta.requiredPermissions) {
            if (!isAuthenticated) {
                // eslint-disable-next-line no-console
                authLoggingEnabled && console.log(authLogPrefix + "calling loginRedirect()");

                // only actually attempt to login if this route requires some kind of permission
                await auth.msalInstance.loginRedirect(auth.getMSALRequest());
                return;
            }

            if (to.meta && to.meta.requiredPermissions && !auth.hasPermissions(to.meta.requiredPermissions)) {
                // not authorized to see page, redirect somewhere else

                // eslint-disable-next-line no-console
                authLoggingEnabled && console.log(authLogPrefix + "not authorized to see this page, redirecting to /notauthorized");

                next({
                    path: "/notauthorized"
                });

                return;
            }

            // eslint-disable-next-line no-console
            authLoggingEnabled && console.log(authLogPrefix + "authenticated => next()");

            // - user is authorized to see the page => display the page
            next();

            return;
        } else {
            // eslint-disable-next-line no-console
            authLoggingEnabled && console.log(authLogPrefix + "no authentication required => next()");

            // some special cases

            if (to.name === "logout") {
                // this will clear internal storage of our user details, and redirect us to the AD logout page
                await auth.logout();
            }

            // no permissions required to access this page => display the page
            next();
            return;
        }
    } 
    catch(e){
        //nothing
    }
    finally {
        store.commit("generalStore/setLoadingRoute", false);
    }
});

export default router;